import classNames from 'classnames'
import { Input } from 'legacy/lut/library/inputs'
import { ValidateInput } from 'legacy/lut/library/validation'
import { lookupGetStateOld } from 'legacy/lut/store'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Dropdown } from 'core-components/library/dropdown'

import { getCountriesCodeSource } from './helpers/getCountriesCodeSource'
import { getDigitsOnly } from './helpers/getDigitsOnly'
import { IPhoneEditor } from './models'

import styles from './PhoneEditor.module.scss'

export const PhoneEditor = ({
  checkCodeFn,
  checkPhoneFn,
  className,
  codeValue,
  isAutoFocus,
  isDisabled,
  label,
  codeLabel,
  margin,
  onCodeChange,
  onPhoneChange,
  phoneValue,
  translation,
  field,
}: IPhoneEditor) => {
  const [t] = useTranslation()

  const countryCodesSource = useMemo(() => {
    const { countriesCode }: { countriesCode: Record<string, any> } = lookupGetStateOld().references

    return getCountriesCodeSource({
      countriesCode,
      defaultCountryValue: countriesCode[codeValue],
    })
  }, [codeValue])

  const phoneInputProps = {
    margin,
    autoFocus: isAutoFocus,
    disabled: isDisabled,
    translation,
    label,
    className: styles.input,
    value: phoneValue,
    onChange: (value: string) => {
      const newValue = getDigitsOnly(value)
      onPhoneChange(newValue)
    },
  }

  return (
    <div className={classNames(styles.selectWrapper, className || '')}>
      <Dropdown
        label={codeLabel || t('bpreg-phone-editor-code')}
        classes={{
          controlClasses: {
            root: styles.select,
          },
        }}
        disabled={isDisabled}
        caption={'label'}
        source={countryCodesSource}
        value={codeValue}
        onChange={onCodeChange}
        checkFn={checkCodeFn}
      />
      {checkPhoneFn ? (
        <ValidateInput {...phoneInputProps} field={field} checkFn={checkPhoneFn} />
      ) : (
        <Input {...phoneInputProps} />
      )}
    </div>
  )
}
